module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "name": "hello-world",
      "width": _vm.modal.width,
      "height": "auto",
      "adaptive": true,
      "scrollable": ""
    }
  }, [_c('div', {
    staticClass: "grid edit ombrello w100"
  }, [_c('div', {
    staticClass: "grid data h50"
  }, [(_vm.$mq === 'sm') ? _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.hide()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times-circle"
  })]) : _vm._e(), _vm._v(" "), _c('el-form', [(!_vm.editombrid) ? _c('h1', {
    on: {
      "click": _vm.changeombrid
    }
  }, [_vm._v(_vm._s(_vm.ombrellos.ombrid))]) : _vm._e(), _vm._v(" "), _c('el-form-item', [(_vm.editombrid) ? _c('el-input', {
    model: {
      value: (_vm.ombrellos.ombrid),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "ombrid", $$v)
      },
      expression: "ombrellos.ombrid"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nome ospite"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nome ospite"
    },
    model: {
      value: (_vm.ombrellos.guest),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "guest", $$v)
      },
      expression: "ombrellos.guest"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Camera"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numero camera"
    },
    model: {
      value: (_vm.ombrellos.room),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "room", $$v)
      },
      expression: "ombrellos.room"
    }
  })], 1), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Arrivo e Partenza")])]), _vm._v(" "), _c('DateRange', {
    staticClass: "calendar",
    attrs: {
      "sync-range": _vm.hellorange,
      "first-day-of-week": 1,
      "lang": _vm.lang,
      "emitChangeOnStep0": true,
      "dayClassFunc": _vm.dayClassFunc
    },
    on: {
      "update:syncRange": function($event) {
        _vm.hellorange = $event
      },
      "update:sync-range": function($event) {
        _vm.hellorange = $event
      },
      "change": _vm.onChangedate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " spacer sm"
  }), _vm._v(" "), _c('p', [(!_vm.ombrellos.free) ? _c('a', {
    staticClass: "btn btn-green block",
    on: {
      "click": _vm.updateombrello
    }
  }, [_vm._v("Salva Ombrello")]) : _vm._e()]), _vm._v(" "), _c('p', [(_vm.ombrellos.free) ? _c('a', {
    staticClass: "btn btn-green block",
    on: {
      "click": _vm.saveOmbrello
    }
  }, [_vm._v("Salva Ombrello")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: " spacer md"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grid seats",
    class: {
      free: _vm.ombrellos.free
    }
  }, [_c('div', {
    staticClass: "grid qrcode"
  }, [(_vm.hotel.cashier && _vm.ombrellos.cashable && _vm.hotel.seasons.length !== 0) ? _c('div', {
    staticClass: "grid cash"
  }, [_c('span', [_c('small', [_vm._v("Base")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("€ " + _vm._s(_vm.cashier.tocash))])]), _vm._v(" "), _c('span', [_c('small', [_vm._v("Extra")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("€ " + _vm._s(_vm.cashier.extra))])]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Totale:")])]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v("€ " + _vm._s(_vm.cashier.total))])])]) : _vm._e(), _vm._v(" "), (_vm.ombrellos.passid && !_vm.ombrellos.free) ? _c('qrcode', {
    attrs: {
      "value": 'https://spiaggia.ombrelleria.com/api/get/pass/' + _vm.ombrellos.passid,
      "options": {
        width: 148
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_c('el-form', [(_vm.sendPassForm) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "email"
    },
    model: {
      value: (_vm.guest.email),
      callback: function($$v) {
        _vm.$set(_vm.guest, "email", $$v)
      },
      expression: "guest.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sendPassForm) ? _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-green block",
    on: {
      "click": _vm.sendPass
    }
  }, [_vm._v("manda beachpass")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "Note"
    },
    model: {
      value: (_vm.ombrellos.note),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "note", $$v)
      },
      expression: "ombrellos.note"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.ombrellos.items), function(item) {
    return _c('div', {
      staticClass: "grid"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _vm._v(" "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          item.num -= 1
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-minus-square"
    })]), _vm._v(_vm._s(item.num)), _c('a', {
      on: {
        "click": function($event) {
          item.num += 1
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-plus-square"
    })])])])
  }), 0)]), _vm._v(" "), (!_vm.ombrellos.free) ? _c('div', {
    staticClass: "grid navi ombrellooptions"
  }, [_c('div', {
    staticClass: "grid shader"
  }, [_c('div', {
    staticClass: "options"
  }, [(!_vm.ombrellos.passid && !_vm.ombrellos.free) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Crea Beachpass",
      "placement": "left-start"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generatePass
    }
  }, [_c('i', {
    staticClass: "fas fa-qrcode"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.ombrellos.passid && !_vm.ombrellos.free) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "manda beachpass tramite email",
      "placement": "left-start"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.sendPassForm = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-envelope"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "left-start"
    }
  }, [_c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Cancella prenotazione")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisibleOmbrello = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  })])], 1)], 1)])]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Attenzione",
      "visible": _vm.dialogVisibleOmbrello,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleOmbrello = $event
      }
    }
  }, [_c('p', [_vm._v("Sei sicuro di voler cancellare la prenotazione per " + _vm._s(_vm.ombrellos.ombrid) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.dialogVisibleOmbrello = false
      }
    }
  }, [_vm._v("Anulla")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        return _vm.closeombrello(_vm.ombrellos.guestnr)
      }
    }
  }, [_vm._v("Cancella")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26055d80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello-World.vue
// module id = 626
// module chunks = 1